import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Pagination } from 'swiper/modules';
import { FaQuoteLeft } from 'react-icons/fa';
import '../../styles/HomeComponents/Testimonials.css';

const Testimonials = ({
  role = [],
  heading = "What our customers say",
  subheading = "Strawket has transformed the learning experience!",
}) => {
  const [testimonials, setTestimonials] = useState([]);
  const [loading, setLoading] = useState(true);

  const REPO = process.env.REACT_APP_CONTENT_REPO; // e.g., strawket/strawket-content
  const BRANCH = process.env.REACT_APP_CONTENT_BRANCH; // e.g., main

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        const res = await axios.get(
          `https://api.github.com/repos/${REPO}/contents/tests?ref=${BRANCH}`
        );

        const files = res.data.filter((file) => file.name.endsWith('.md'));

        const fetchEach = async (file) => {
          try {
            const contentRes = await axios.get(file.download_url);
            const content = contentRes.data;

            const frontmatterMatch = content.match(/---\n([\s\S]*?)\n---/);
            const message = content.replace(/---\n([\s\S]*?)\n---/, '').trim();

            if (!frontmatterMatch) return null;

            const frontmatterLines = frontmatterMatch[1].split('\n');
            const data = {};
            frontmatterLines.forEach((line) => {
              const [key, ...rest] = line.split(':');
              data[key.trim()] = rest.join(':').trim().replace(/^"|"$/g, '');
            });

            let profileImageUrl = null;
            if (data.profile) {
              profileImageUrl = `https://raw.githubusercontent.com/${REPO}/${BRANCH}/images/${data.profile}`;
            }

            return {
              ...data,
              message,
              profile: profileImageUrl,
            };
          } catch (err) {
            console.error('❌ Error fetching testimonial:', err);
            return null;
          }
        };

        const rawData = await Promise.all(files.map(fetchEach));
        const filteredData = rawData.filter(
          (item) => item && item.role && (role.length === 0 || role.includes(item.role))
        );

        filteredData.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        setTestimonials(filteredData);
      } catch (error) {
        console.error('Error fetching testimonials:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchTestimonials();
  }, [role]);

  return (
    <section className="testimonials-section">
      <div className="testimonial-heading">
        <h2>{heading}</h2>
        <p>{subheading}</p>
      </div>

      {loading ? (
        <p className="testimonial-empty">Loading testimonials...</p>
      ) : testimonials.length > 0 ? (
        <Swiper
          slidesPerView={1.2}
          centeredSlides={true}
          spaceBetween={20}
          pagination={{ clickable: true }}
          grabCursor={true}
          modules={[Pagination]}
          breakpoints={{
            480: { slidesPerView: 1.2 },
            640: { slidesPerView: 1.3 },
            768: { slidesPerView: 1.5 },
            1024: { slidesPerView: 2.4 },
          }}
        >
          {testimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-card">
                <FaQuoteLeft className="quote-icon" />
                <p className="testimonial-message">{item.message}</p>
                <div className="testimonial-user">
                  <img
                    src={
                      item.profile
                        ? item.profile
                        : require('../../assets/Images/avatar.jpeg')
                    }
                    alt={item.name}
                    className="testimonial-avatar"
                  />
                  <div>
                    <h4 className="testimonial-name">{item.name}</h4>
                    <p className="testimonial-role">{item.designation}</p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <p className="testimonial-empty">No testimonials found.</p>
      )}
    </section>
  );
};

export default Testimonials;